import React from 'react'
import styles from './DataTable.css'
import PropTypes from "prop-types"
import {autoFormatter} from '../../services/service-auto-formatter'

const DataTable = (props) => (
  <div className={styles.DataTable} {...props}>
    {props.items.map((dataItem, idx) => (
      <div
        key={idx}
        className={styles.dataItem}
        dangerouslySetInnerHTML={{__html: autoFormatter(dataItem)}}
      >
      </div>
    ))}
  </div>
)

DataTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
}

export default DataTable



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTable.js